import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import MultipleSelectNative from './MultipleSelectNative';
import ClientProvider from './client';
export default createDemo(import.meta.url, MultipleSelectNative, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/selects/demos/multiple-native/MultipleSelectNative.tsx",
    "fileName": "MultipleSelectNative.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport InputLabel from '@mui/material/InputLabel';\nimport FormControl from '@mui/material/FormControl';\nimport Select from '@mui/material/Select';\n\nconst names = [\n  'Oliver Hansen',\n  'Van Henry',\n  'April Tucker',\n  'Ralph Hubbard',\n  'Omar Alexander',\n  'Carlos Abbott',\n  'Miriam Wagner',\n  'Bradley Wilkerson',\n  'Virginia Andrews',\n  'Kelly Snyder',\n];\n\nexport default function MultipleSelectNative() {\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 0,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  const id = React.useId();\n  const [personName, setPersonName] = React.useState<string[]>([]);\n  const handleChangeMultiple = (event: React.ChangeEvent<HTMLSelectElement>) => {\n    const { options } = event.target;\n    const value: string[] = [];\n    for (let i = 0, l = options.length; i < l; i += 1) {\n      if (options[i].selected) {\n        value.push(options[i].value);\n      }\n    }\n    setPersonName(value);\n  };\n\n  return (\n    <div>\n      <FormControl sx={{ m: 1, minWidth: 120, maxWidth: 300 }}>\n        <InputLabel shrink htmlFor={`${id}-select`}>\n          Native\n        </InputLabel>\n        <Select<string[]>\n          multiple\n          native\n          value={personName}\n          onChange={handleChangeMultiple}\n          label=\"Native\"\n          inputProps={{\n            id: `${id}-select`,\n          }}\n        >\n          {names.map((name) => (\n            <option key={name} value={name}>\n              {name}\n            </option>\n          ))}\n        </Select>\n      </FormControl>\n    </div>\n  );\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 58,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport InputLabel from '@mui/material/InputLabel';\nimport FormControl from '@mui/material/FormControl';\nimport Select from '@mui/material/Select';\n\nconst names = [\n  'Oliver Hansen',\n  'Van Henry',\n  'April Tucker',\n  'Ralph Hubbard',\n  'Omar Alexander',\n  'Carlos Abbott',\n  'Miriam Wagner',\n  'Bradley Wilkerson',\n  'Virginia Andrews',\n  'Kelly Snyder',\n];\n\nexport default function MultipleSelectNative() {\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 0
        },
        "  const id = React.useId();\n  const [personName, setPersonName] = React.useState<string[]>([]);\n  const handleChangeMultiple = (event: React.ChangeEvent<HTMLSelectElement>) => {\n    const { options } = event.target;\n    const value: string[] = [];\n    for (let i = 0, l = options.length; i < l; i += 1) {\n      if (options[i].selected) {\n        value.push(options[i].value);\n      }\n    }\n    setPersonName(value);\n  };\n\n  return (\n    <div>\n      <FormControl sx={{ m: 1, minWidth: 120, maxWidth: 300 }}>\n        <InputLabel shrink htmlFor={`${id}-select`}>\n          Native\n        </InputLabel>\n        <Select<string[]>\n          multiple\n          native\n          value={personName}\n          onChange={handleChangeMultiple}\n          label=\"Native\"\n          inputProps={{\n            id: `${id}-select`,\n          }}\n        >\n          {names.map((name) => (\n            <option key={name} value={name}>\n              {name}\n            </option>\n          ))}\n        </Select>\n      </FormControl>\n    </div>\n  );\n"
      ],
      [
        "span",
        "frame",
        "}\n"
      ]
    ],
    "totalLines": 58,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/InputLabel",
      "@mui/material/FormControl",
      "@mui/material/Select"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
